import { render, staticRenderFns } from "./CaseProvince.vue?vue&type=template&id=4aaca2f0&scoped=true"
import script from "./CaseProvince.vue?vue&type=script&lang=js"
export * from "./CaseProvince.vue?vue&type=script&lang=js"
import style0 from "./CaseProvince.vue?vue&type=style&index=0&id=4aaca2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaca2f0",
  null
  
)

export default component.exports